import React from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Layout from "../components/common/Layout";
import ProtectedRoute from "../components/common/ProtectedRoute";

// Import pages
import LoginPage from "../pages/auth/LoginPage";
import DashboardPage from "../pages/dashboard/DashboardPage";
import MachinesPage from "../pages/machines/MachinesPage";
import MachineDetailsPage from "../pages/machines/MachineDetailsPage";
import TrashedMachinesPage from "../pages/machines/TrashedMachinesPage";
import AlertsPage from "../pages/alerts/AlertsPage";
import SuperAdminTenantsPage from "../pages/super-admin/TenantsPage";
import TenantMachinesPage from "../pages/super-admin/TenantMachinesPage";
import TenantUsersPage from "../pages/super-admin/TenantUsersPage";
import TenantAlertsPage from "../pages/super-admin/TenantAlertsPage";
import TenantBranchesPage from "../pages/super-admin/TenantBranchesPage";
import CompanySettingsPage from "../pages/company/CompanySettingsPage";
import ReportsPage from "../pages/reports/ReportsPage";

// Suprimir warning do React Router v7 (não disponível na versão 6.10.0)
const originalWarn = console.warn;
console.warn = (...args: any[]) => {
  if (args[0]?.includes?.('React Router Future Flag Warning')) {
    return; // Suprimir apenas o warning do React Router
  }
  originalWarn.apply(console, args);
};

const router = createBrowserRouter(
  [
    {
      path: "/login",
      element: <LoginPage />,
    },
  {
    path: "/",
    element: (
      <Layout>
        <ProtectedRoute>
          <DashboardPage />
        </ProtectedRoute>
      </Layout>
    ),
  },
  {
    path: "/machines",
    element: (
      <Layout>
        <ProtectedRoute>
          <MachinesPage />
        </ProtectedRoute>
      </Layout>
    ),
  },
  {
    path: "/machines/trash",
    element: (
      <Layout>
        <ProtectedRoute>
          <TrashedMachinesPage />
        </ProtectedRoute>
      </Layout>
    ),
  },
  {
    path: "/machines/:id",
    element: (
      <Layout>
        <ProtectedRoute>
          <MachineDetailsPage />
        </ProtectedRoute>
      </Layout>
    ),
  },
  {
    path: "/alerts",
    element: (
      <Layout>
        <ProtectedRoute>
          <AlertsPage />
        </ProtectedRoute>
      </Layout>
    ),
  },
  {
    path: "/super-admin/tenants",
    element: (
      <Layout>
        <ProtectedRoute requiredRole="super_admin">
          <SuperAdminTenantsPage />
        </ProtectedRoute>
      </Layout>
    ),
  },
  {
    path: "/super-admin/tenants/:tenantId/machines",
    element: (
      <Layout>
        <ProtectedRoute requiredRole="super_admin">
          <TenantMachinesPage />
        </ProtectedRoute>
      </Layout>
    ),
  },
  {
    path: "/super-admin/tenants/:tenantId/users",
    element: (
      <Layout>
        <ProtectedRoute requiredRole="super_admin">
          <TenantUsersPage />
        </ProtectedRoute>
      </Layout>
    ),
  },
  {
    path: "/super-admin/tenants/:tenantId/alerts",
    element: (
      <Layout>
        <ProtectedRoute requiredRole="super_admin">
          <TenantAlertsPage />
        </ProtectedRoute>
      </Layout>
    ),
  },
  {
    path: "/super-admin/tenants/:tenantId/branches",
    element: (
      <Layout>
        <ProtectedRoute requiredRole="super_admin">
          <TenantBranchesPage />
        </ProtectedRoute>
      </Layout>
    ),
  },
  {
    path: "/settings",
    element: (
      <Layout>
        <ProtectedRoute requiredRole="tenant_admin">
          <CompanySettingsPage />
        </ProtectedRoute>
      </Layout>
    ),
  },
  {
    path: "/reports",
    element: (
      <Layout>
        <ProtectedRoute>
          <ReportsPage />
        </ProtectedRoute>
      </Layout>
    ),
  },
  ]
);

export default function AppRouter() {
  return <RouterProvider router={router} />;
}
